import { render, staticRenderFns } from "./personal-privacy.vue?vue&type=template&id=365f521c&scoped=true&lang=pug&"
var script = {}
import style0 from "./personal-privacy.vue?vue&type=style&index=0&id=365f521c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365f521c",
  null
  
)

export default component.exports